/**
 * What the fact-find page shows. Only a list that never loaded is an error:
 * a failed refetch after a save keeps the cached list, so the form stays up.
 * A submitted fact-find is read-only, except while this visit's post-submit
 * modals are open.
 */
export const factFindView = ({
  isLoading,
  listError,
  hasList,
  submitted,
  postSubmitOpen,
}: {
  isLoading: boolean;
  listError: boolean;
  hasList: boolean;
  submitted: boolean;
  postSubmitOpen: boolean;
}): 'loading' | 'error' | 'summary' | 'form' => {
  if (isLoading) return 'loading';
  if (listError && !hasList) return 'error';
  if (submitted && !postSubmitOpen) return 'summary';
  return 'form';
};
